import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api } from "../lib/api";
import { useSite } from "../lib/site";
import { Button } from "../components/ui/button";
import { BrandedLabel } from "../components/BrandedLabel";

export const areaQrValue = (area) => `AREA:${area.id}`;

export default function AreaLabels() {
  const [params] = useSearchParams();
  const { site } = useSite();
  const [areas, setAreas] = useState([]);
  useEffect(() => {
    api.get("/areas").then((r) => setAreas(params.get("area") ? r.data.filter((a) => a.id === params.get("area")) : r.data));
  }, [params]);
  return (
    <div data-testid="area-labels-page">
      <div className="no-print mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="eyebrow text-rose-400">{site?.name}</p>
          <h1 className="font-display text-3xl font-extrabold uppercase">Area QR check-in labels</h1>
          <p className="text-sm text-slate-400">Print and fix at the entrance to each area. Auditors scan on arrival to verify they walked the route.</p>
        </div>
        <Button onClick={() => window.print()} className="tap bg-rose-600 hover:bg-rose-700" data-testid="print-area-labels-btn"><Printer className="mr-2 h-4 w-4" />Print labels</Button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 print:grid-cols-2">
        {areas.map((a) => (
          <BrandedLabel key={a.id} title={a.name} code={a.code} sub={site?.name} qrValue={areaQrValue(a)} footer="Scan me on arrival - area check-in" testid={`area-label-${a.code}`} />
        ))}
      </div>
    </div>
  );
}
